export default "__VITE_ASSET__D342ISDQ__"